import React, { useState, useEffect } from 'react';
import ReactDOM from 'react';
import PropTypes from 'prop-types';
import { render } from 'react-dom';

import DataBus from '../../databus'

import { DcContext } from '../../components/context';
import FormState from '../../formstate';

import Login from '../../components/login';
import LegalText from '../../components/legaltext';
import Single from '../../components/single';
import Multiple from '../../components/multiple';
import Header from '../../components/header';
import Intro from '../../components/intro';
import Reset from '../../components/reset';
// REMOVE import Tabs from '../../components/tabs';
// ?? import ToolSelect from '../../components/toolSelect';


const Disclaimer = (props) => {
	// * state setup 
	const [loginMode, setLoginMode] = useState(0); 				// 0 = no login, 1 = config login, 2 = userSettings login
	const [passwordHash, setPasswordHash] = useState(''); 
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [dcConfig, setDcConfig] = useState({});
	const [dcData, setDcData] = useState({});
	const [dcDataIsSet, setDcDataIsSet] = useState(false);
	const [userSettingsIsSet, SetUserSettingsIsSet] = useState(false);
	const [formState, setFormState] = useState(FormState);

	// * context object
	const appContext = {
		getFormState: () => {
			return formState;
		},
		setFormState: (fs) => {
			//console.log('setFormState', fs.sectionItems); 
			setFormState({ ...fs });
		},
		getDcData: () => {
			return dcData;
		},
		getIsLoggedIn: () => {
			return isLoggedIn;
		},
		setIsLoggedIn: (loggedIn) => {
			setIsLoggedIn(loggedIn);
		},
	};

	// * set global disclaimer data (callback fn)
	const setDcDataConfig = (config, data) => {
		if (!dcDataIsSet) {
			const fs = formState;
			
			// get password hash from config 
			if (getLoginMode() === 1) {
				setPasswordHash(config.SecretPassword); 
			}

			//console.log('setDcDataConfig', config, data);
			setDcConfig(config);
			setDcData(data);
			// pass config into formstate
			fs.config = config;
			fs.resetOffer();
			setFormState(fs);
			setDcDataIsSet(true);
		}
	};

	// * set user settings data (callback fn)
	const setUserSettings = (config, userSettings) => {
		if (!userSettingsIsSet) {
			const fs = formState;
			fs.userSettings = userSettings;
			setFormState(fs); 
			SetUserSettingsIsSet(true); 
			console.log('FormState.userSettings', fs.userSettings); 
			// get password hash from usersettings 
			if (getLoginMode() === 2) {
				// sometimes the google sheet refuses to run the GetSHA1 app script function
				// note that it always seems to work the second time
				if (userSettings.HashValue === "#NAME?") {
					// fall back to config file password 
					console.log("Hash Value not loaded!", userSettings.HashValue, config.SecretPassword);
					setLoginMode(1); 
					setPasswordHash(config.SecretPassword);
				} else {
					// use the hash from the spreadsheet 
					setPasswordHash(userSettings.HashValue);
					console.log("userSettings.HashValue", userSettings.HashValue); 
				}
			
			}
		}
	}; 

	// check which top security high integrity password should be displayed 
	const getLoginMode = () => {
		//console.log('pageConfig', pageConfig); 
		let lm = 0; 
		if (pageConfig && pageConfig.cauliflower) {
			if (pageConfig.broccoli) {
				lm = 2; 
			} else {
				lm = 1; 
			}
		}
		setLoginMode(lm); 
		console.log('loginMode', lm); 
		return lm; 
	}; 

	useEffect(() => {
		//console.log('Disclaimer useEffect', props);

		// see if dcData has been loaded and bring it into state	
		if (DataBus.haveData) {
			setDcDataConfig(DataBus.config, DataBus.data);
		} else {
			// no data yet, 
			// create callback for data load 
			DataBus.dataEvents.setDCData = (config, data) => {
				//console.log('dcdata callback');
				setDcDataConfig(config, data);
			}
		}

		// see if userSettings has been loaded and bring it into formState
		if (DataBus.haveUserSettings) {
			setUserSettings(DataBus.config, DataBus.userSettings);
		} else {
			// create callback for data load 
			DataBus.dataEvents.setUserSettings = (config, userSettings) => {
				//console.log('settings callback')
				setUserSettings(config, userSettings); 
			};
		}
		
	}, []);

	// * componentUpdate
	/*
	useEffect(
		() => {
			console.log('update?');
		},
		[formState]
	); 
	*/

	// * helper to filter offertypes 
	const checkOfferType = (itemOT, selectedOT) => {
		//if (!itemOT || !selectedOT || selectedOT == DisclaimerConfig.OfferTypeAll) {
		if (selectedOT == dcConfig.OfferTypeAll) {
			return true;
		} else if (!itemOT) {
			return true;
		} else if (!selectedOT) {
			return false;
		} else {
			//console.log("checkOfferType", itemOT, selectedOT );
			// check indexOf 
			return (itemOT.toLowerCase().indexOf(selectedOT.toLowerCase()) >= 0);
		}
	};

	// * disclaimer form rendering  
	const disclaimerForm = () => {
		const fs = appContext.getFormState();
		// offer sections 
		let sections = [];
		let section;
		//console.log(dcData, fs);
		if (!dcConfig['Sections']) {
			return (
				<div className="noconfig"></div>
			);
		}

		dcConfig['Sections'].forEach((sec) => {
			//console.log(sec);
			let showSection = !sec.special;

			// determine if product specific sections should be shown  

			if (showSection) {
				// build control options for each section 
				let secOpts = [];
				section = dcData[sec.key];
				//console.log('section', sec.key, section);
				if (section) {
					section.forEach((item) => {
						//console.log('item', item);
						// filter region 
						let addIt = (!sec.filterRegion || item[fs.getRegion()]);
						//console.log('check', !sec.filterOfferType , item.offertype, fs.getOfferType() );
						// filter offer type 
						addIt = addIt && (!sec.filterOfferType || checkOfferType(item.offertype, fs.getOfferType()));
						// filter region tabs 
						if (sec.key == dcConfig.RegionSection) {
							addIt = addIt && (item[item.key.toLowerCase()] == true);
						}
						if (addIt) {
							secOpts.push({
								value: item.key,
								label: item.desc,
								tip: item.tip,
								products: sec.product,
								companies: { chtr: item.chtr, twc: item.twc, twchi: item.twchi, bhn: item.bhn }
							});
						}
					});
				}
				//console.log('secOpts', section, secOpts);
				if (sec.type == "single" || sec.type == "tabs") {
					// radio btns or tab bar
					sections.push(

						<Single key={sec.key}
							name={sec.key}
							options={secOpts}
							selected={fs.getSectionOption(sec.key)[0] || "n/a"}
							updateType='section'
							updateVal={sec.key}
							heading={sec.label ? sec.label : sec.key}
							region={fs.getRegion()}
							product={sec.product} productOpts={sec.productOpts}
							autoSelect={sec.autoSelect == true && fs.isReset()}
							tabs={sec.type == "tabs"}
							headingType={sec.heading}
							closed={sec.closed}
						/>

					);
				} else if (sec.type == "multiple") {
					// checkboxes 
					sections.push(

						<Multiple key={sec.key}
							name={sec.key}
							options={secOpts}
							selected={fs.getSectionOption(sec.key)}
							updateType='section'
							updateVal={sec.key}
							heading={sec.label ? sec.label : sec.key}
							product={sec.product} productOpts={sec.productOpts}
							autoSelect={sec.autoSelect == true && fs.isReset()}
							headingType={sec.heading}
							closed={sec.closed}
						/>

					)
				}
			}
		});

		//fs.clearReset();
		//console.log('render disclaimer', fs.isReset())
		//setFormState(fs); 

		const formClass = 'offer-options ' + dcConfig.FormClass; 

		return (
			<form className={formClass} name='disclaimer-form'>
				<div className='sections'>
					{sections}
				</div>
			</form>
		);
	}


	// * Render 
	let form;
	if (isLoggedIn || loginMode === 0) {
		form = (
				<div className='form-content'>
					<Intro></Intro>
					<Reset></Reset>
					{disclaimerForm()}
					<Reset></Reset>
					<LegalText formState={formState} config={dcConfig} />
				</div>
		);
	} else {
		form = (
			<Login loggedIn={isLoggedIn} hashValue={passwordHash} appId={dcConfig.AppID} />
		);
	}

	return (
		<div className="page-index">
			<Header text={dcConfig.Title} />
			<DcContext.Provider value={appContext}>
				{form}
			</DcContext.Provider>
		</div>
	);


};



export default Disclaimer; 